import { createSelector } from 'reselect';

export const searchSelector = createSelector(
  (state) => state.search,
  (search) => search
);
